import { render, staticRenderFns } from "./PageWrap.vue?vue&type=template&id=3ff14351&scoped=true"
import script from "./PageWrap.vue?vue&type=script&lang=js"
export * from "./PageWrap.vue?vue&type=script&lang=js"
import style0 from "./PageWrap.vue?vue&type=style&index=0&id=3ff14351&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff14351",
  null
  
)

export default component.exports